// extracted by mini-css-extract-plugin
module.exports = {"kicker":"default_kicker__33qCG","label":"default_label__L4NP7"};